import { OrbitControls, PerspectiveCamera } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { FunctionComponent, useEffect, useState } from "react"
import { a, useTrail } from 'react-spring'
import { ResizeObserver } from '@juggle/resize-observer';
import '../../App.scss';

const desctriptions1 = [
  {
    main: "What is it?",
    sub: "This Javascript library is one of the most recognized tools for building beautiful and dynamic UIs."
  },
  {
    main: "Why use it?",
    sub: "Its declarative nature lets the developer create reusable components. Allowing for a shorter development time and a better development experience."
  },
  {
    main: "How long have I been using it?",
    sub: "I've been using it for the past 3 years within web and mobile projects. And it's definitely one of the best libraries I've ever used."
  },
]

const desctriptions2 = [
  {
    main: "What is it?",
    sub: "This is a Javascript 3D library that makes it possible to render 3D scenes inside the web browser."
  },
  {
    main: "Why use it?",
    sub: "If used in combination with React, it allows us to add a degree of freedom by merging 2D and 3D elements and create interesting UIs that are meant to amaze."
  },
  {
    main: "How long have I been using it?",
    sub: "During the past year I took Computer Graphics classes that used this library to teach 3D fundamentals."
  },
]

const desctriptions3 = [
  {
    main: "UmHelp - React Native Developer",
    sub: "Member of the team responsible for developing the frontend of the Provider and Client App."
  },
  {
    main: "Klubi - Full Stack Developer",
    sub: "Helped develop the Startup's website initial release. Adding payment features, fixing the frontend, and enhancing the backend's functionality."
  },
  {
    main: "This Website",
    sub: "This website was entirely created by me using React with Typescript and Three.js."
  }
]

interface Desctription {
  main: string,
  sub: string
}

interface Props {
  activeScene: number
  width: number
  breakpoint: number
}

const WebDev: FunctionComponent<Props> = (props) => {
  const { width, breakpoint } = props
  
  const [open, set] = useState(false) 
  const items = [0, 1, 2, 3, 4]
  const trail = useTrail(items.length, {
    config: { mass: 4, tension: 1400, friction: 200 },
    opacity: open ? 1 : 0,
    x: open ? 0 : 80,
    minus_x: open ? 0 : -80,
    angle: open ? 0 : 100
  })

  const column = (title: string, icon: string, texts: Desctription[]) => {

    return(
      <div className="three-containers">
        <a.div className="icon-container" style={{ x: trail[3].x, opacity: trail[3].opacity, rotateZ: trail[3].angle }}>
          <img
            src={process.env.PUBLIC_URL + '/' + icon}
            style={{
              height: "50%",
              color: "white",
              zIndex: 20
            }}
          />
        </a.div>
        <a.div className="column-title" style={{ opacity: trail[1].opacity, x: trail[1].x }}>{title}</a.div>
        <div>
          {texts.map(({ main, sub }, i) => (
            <div className="about-list-item">
              <a.div className="about-text justify" style={{ opacity: trail[i+1].opacity, x: trail[i+1].x }}>{main}</a.div>
              <a.div className="about-text-small justify" style={{ opacity: trail[i+1].opacity, x: trail[i+1].x }}>{sub}</a.div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  useEffect(() => {
    set(props.activeScene === 1)
  }, [props.activeScene])

  return(
    <div className="subject-canvas web-dev">
      <div style={{ position: "absolute", width: "100%", height: "100%" }}>
        <Canvas resize={{ polyfill: ResizeObserver }} className="canvas">
          <ambientLight intensity={1}  />
          <mesh rotation={[1, 1, 1]}>
            <boxGeometry />
            <meshPhongMaterial />
          </mesh>
          <PerspectiveCamera makeDefault position={[0, 5, 5]}>
            <pointLight position={[5, 5, 0]} color="green" intensity={4} />
            <pointLight position={[-5, 5, 0]} color="purple" intensity={4} />
          </PerspectiveCamera>
          <OrbitControls autoRotate />
        </Canvas>
      </div>
      <div className="container-wd">
        {column("React", "react-icon.svg", desctriptions1)}
        {column("Three.js", "threejs-icon.svg", desctriptions2)}
        {column("Work Experience", "work-icon.svg", desctriptions3)}
        {width < breakpoint
          ? <div style={{ minHeight: "6rem" }} />
          : null
        }
      </div>
    </div>
  )
}

export { WebDev }